import React, { Component } from 'react';
import  ReactDOM from 'react-dom'

import  "./bbutil"
import BBIFrame from './BBIFrame';

class BBTreeTable extends BBIFrame {

 



  getUrl()
  {

    return "/bb/w2ui/treetable.html";
   // return "/bb/map/leafletWidgetDeploy.html";
  }
  
}

export default BBTreeTable; 